/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".perfil[_ngcontent-%COMP%]{\r\n    text-align: center;\r\n    margin: 0 auto;\r\n    position: relative\r\n}\r\n.img[_ngcontent-%COMP%]{\r\n    position:relative;\r\n}\r\n.foto[_ngcontent-%COMP%]{\r\n    z-index:1 ;\r\n\r\n}\r\n.takePhoto[_ngcontent-%COMP%]{\r\n    z-index: 2;\r\n    position:absolute;\r\n    margin-top: -77px;\r\n    margin-left:264px;\r\n}"];
export { styles as styles };
